import { fetchAuthSession } from 'aws-amplify/auth';
import { config } from '../config/Config';

export const convertObjectBodyString = (dataObject: Record<string, string | number | boolean>) =>
  Object.entries(dataObject)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

const getAuthHeaders = async (): Promise<Record<string, string>> => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    if (token) return { Authorization: token };
  } catch {
    // Not authenticated
  }
  return {};
};

interface ApiOptions {
  headers?: Record<string, string>;
  queryStringParameters?: Record<string, string>;
  body?: string | Record<string, unknown>;
}

export const apiGet = async (path: string, { headers, queryStringParameters }: ApiOptions = {}) => {
  const authHeaders = await getAuthHeaders();
  const url = new URL(`${config.apiGateway.ENDPOINT}${path}`);
  if (queryStringParameters) {
    Object.entries(queryStringParameters).forEach(([k, v]) => url.searchParams.set(k, v));
  }
  // Callers may pass a bare string token as headers (legacy) — ignore it since getAuthHeaders() handles auth
  const extraHeaders = typeof headers === 'object' && headers !== null ? headers : {};
  const res = await fetch(url, { headers: { ...authHeaders, ...extraHeaders } });
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
};

export const apiPost = async (path: string, { headers, body }: ApiOptions = {}) => {
  const authHeaders = await getAuthHeaders();
  const extraHeaders = typeof headers === 'object' && headers !== null ? headers : {};
  const res = await fetch(`${config.apiGateway.ENDPOINT}${path}`, {
    method: 'POST',
    headers: {
      ...authHeaders,
      ...extraHeaders,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
};
